/**
 * USP Bar Component
 * Integrates with the theme's component system for proper lifecycle management
 */
(function() {
  const uspBar = window.component((element) => {
    const uspId = element.dataset.uspId;
    const sliderElement = element.querySelector('[data-slider]');

    if (!sliderElement) {
      console.warn('USP Bar: No slider element found');
      return;
    }

    let slider = null;

    // Wait for KeenSlider to be loaded
    function waitForKeenSlider(callback) {
      if (typeof KeenSlider !== 'undefined') {
        callback();
      } else {
        setTimeout(() => waitForKeenSlider(callback), 100);
      }
    }

    function initializeSlider() {
      // Destroy existing instance if any
      if (slider) {
        try {
          slider.destroy();
        } catch (e) {
          console.warn('Error destroying USP slider:', e);
        }
        slider = null;
      }

      // Create new slider instance with autoplay plugin
      slider = new KeenSlider(
        sliderElement,
        {
          loop: true,
        },
        [
          (slider) => {
            let timeout;
            let mouseOver = false;

            function clearNextTimeout() {
              clearTimeout(timeout);
            }

            function nextTimeout() {
              clearTimeout(timeout);
              if (mouseOver) return;
              timeout = setTimeout(() => {
                slider.next();
              }, 2000);
            }

            slider.on("created", () => {
              slider.container.addEventListener("mouseover", () => {
                mouseOver = true;
                clearNextTimeout();
              });
              slider.container.addEventListener("mouseout", () => {
                mouseOver = false;
                nextTimeout();
              });
              nextTimeout();
            });

            slider.on("dragStarted", clearNextTimeout);
            slider.on("animationEnded", nextTimeout);
            slider.on("updated", nextTimeout);
          },
        ]
      );
    }

    // Initialize when KeenSlider is ready
    waitForKeenSlider(initializeSlider);

    // Cleanup function (called when component is unmounted)
    return () => {
      if (slider) {
        try {
          slider.destroy();
        } catch (e) {
          console.warn('Error cleaning up USP slider:', e);
        }
        slider = null;
      }
    };
  });

  // Add to the component registry
  if (window.app) {
    window.app.add({ uspBar });
  } else {
    // If app isn't ready yet, wait for it
    const checkApp = setInterval(() => {
      if (window.app) {
        clearInterval(checkApp);
        window.app.add({ uspBar });
      }
    }, 50);
  }
})();

